/* eslint-disable @typescript-eslint/no-unused-expressions */
import api from "utilities/Axios";

export const getUserTickets = async () => {
  return api.get("/ticket/getmyticket");
};

export const getTickets = async () => {
  return api.get("/ticket/getallticket");
};

export const createTicket = async (data: any) => {
  return api.post("/ticket/createticket", data);
};

export const closeTicket = (data: any) => {
  return api.post("/ticket/closeticket" + `?id=${data}`);
};

export const rejectTicket = (data: any) => {
  return api.post("/ticket/rejectticket" + `?id=${data}`);
};
export const deleteTicket = (data: any) => {
  return api.post("/ticket/deleteticket" + `?id=${data}`);
};
